export default "__VITE_ASSET__CNDFmwOV__"